import React, { Component } from 'react';
import { Panel } from 'react-bootstrap/lib';
import Icon from 'noc/components/icon';
import classNames from 'classnames';

class NotificationsPanel extends Component {

    constructor(...args) {
        super(...args);
        this.state = {
            open: true
        };
    }

    render() {
        const {
            tabs, requestForId, getTabData, tabsToBeShown, morePopupStatus,
            toggle, columnFilters, swapCustomTabs, refreshGrid, RefreshGridTime,
            ticketCategoryData, refreshCategoryGridTime
        } = this.props;

        let NotificationTotal = 0;
        let WarningTotal = 0;
        let EscalationTotal = 0;

        if (ticketCategoryData != null) {
            ticketCategoryData.map(ticketCategory => {
                ticketCategory.TicketParameter.map(ticketParameter => {
                    if (ticketParameter.ParameterName == 'Notification') {
                        NotificationTotal = NotificationTotal + ticketParameter.Count;
                    }
                    if (ticketParameter.ParameterName == 'Warning') {
                        WarningTotal = WarningTotal + ticketParameter.Count;
                    }
                    if (ticketParameter.ParameterName == 'Escalate') {
                        EscalationTotal = EscalationTotal + ticketParameter.Count;
                    }
                });
            });
        }

        return (
            <section className="ttd-panel">

                <h2 className="ttd-panel__header" role="button" tabIndex="0" aria-expanded="true">
                    <a
                        href="javascript:;"
                        onClick={() => this.setState({ open: !this.state.open })}
                        title="Expand / Collapse"
                    >
                        <Icon type="cn-icon--menu" icon={!this.state.open ? 'icon-triangle-down' : 'icon-triangle-up'} />

                        <strong>
                            NOTIFICATION : {NotificationTotal}
                            | WARNING : {WarningTotal}
                            | ESCALATE : {EscalationTotal}
                        </strong>
                    </a>
                    <span className="ttd-panel__header-info">
                        Last Update {refreshCategoryGridTime ? `${refreshCategoryGridTime}` : ''}
                        <a href="javascript:;">
                            <Icon
                                type="cn-icon--tool" icon="icon-refresh"
                                onClick={() => refreshGrid()}
                            />
                        </a>
                    </span>
                </h2>
                <Panel collapsible expanded={this.state.open}>
                    <div className="ttd-indicator-box">
                        {tabs.map((tab, i) => {
                            if (tab.IsVisible == true) {
                                const ticketCategory = ticketCategoryData != null
                                    ? ticketCategoryData.find(x => x.Id == tab.Id)
                                    : null;
                                let NotificationCount = 0;
                                let WarningCount = 0;
                                let EscalationCount = 0;
                                if (ticketCategory != null) {
                                    ticketCategory.TicketParameter.map(ticketParameter => {
                                        if (ticketParameter.ParameterName == 'Notification') {
                                            NotificationCount = ticketParameter.Count;
                                        }
                                        if (ticketParameter.ParameterName == 'Warning') {
                                            WarningCount = ticketParameter.Count;
                                        }
                                        if (ticketParameter.ParameterName == 'Escalate') {
                                            EscalationCount = ticketParameter.Count;
                                        }
                                    });
                                }
                                const className = classNames({ 'ttd-indicator': true, 'ttd-indicator--selected': requestForId === tab.Id });
                                return (
                                    <div key={i} className={className}>
                                        <div className="ttd-indicator__header">
                                            <a href="#" onClick={() => { getTabData(tab.Id); }} >{tab.DisplayName}</a>
                                        </div>
                                        <a href="#" className="ttd-indicator__count" onClick={() => { getTabData(tab.Id); }} >
                                            {ticketCategory ? `${ticketCategory.TotalCount}` : '0'}
                                        </a>
                                        <ul className="ttd-indicator__content">
                                            <li className="ttd-indicator__item--notification">
                                                <div className="ttd-indicator__item-count">
                                                    {NotificationCount}
                                                </div>
                                                <div className="ttd-indicator__item-text">NOTIFICATION</div>
                                            </li>
                                            <li className="ttd-indicator__item--warning">
                                                <div className="ttd-indicator__item-count">
                                                    {WarningCount}
                                                </div>
                                                <div className="ttd-indicator__item-text">WARNING</div>
                                            </li>
                                            <li className="ttd-indicator__item--escalate">
                                                <div className="ttd-indicator__item-count">
                                                    {EscalationCount}
                                                </div>
                                                <div className="ttd-indicator__item-text">ESCALATE</div>
                                            </li>
                                        </ul>
                                        <Icon type="cn-icon--tool" icon="ttd-arrow" />
                                    </div>
                                );
                            }
                        }
                        )
                        }
                    </div>
                </Panel>
            </section>
        );
    }
}

export default NotificationsPanel;



// WEBPACK FOOTER //
// ./app/tickets/components/NotificationsPanel.jsx